export const DEFAULT_PAGE_SIZE = 10;

/** Height of the sticky LibraryHeader bar in pixels.
 *  Used to offset sticky sidebars so they don't slide behind the header. */
export const HEADER_HEIGHT = 52;

export const ROUTES = {
  library: '/VirtualLibrary',
  browse: '/VirtualLibrary/browse',
  search: '/VirtualLibrary/search',
  accessDenied: '/VirtualLibrary/access-denied',
  createCategory: '/VirtualLibrary/category/create',
  editCategory: '/VirtualLibrary/category/edit',
  deleteCategory: '/VirtualLibrary/category/delete',
  createResource: '/VirtualLibrary/resource/create',
  editResource: '/VirtualLibrary/resource/edit',
} as const;
